import React, { useState, useEffect } from 'react'
import Upload from '../views/media/Upload'
import { getMedia, createMediaItem } from '../api/media'
import config from '../config'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { Storage } from 'aws-amplify'

const MediaPickerModal = (props) => {
    let { id: siteId } = useParams()
    let { pageId } = useParams()
    const [site, setSite] = useState({})
    const [isLoading, setIsLoading] = useState(true)
    const [media, setMedia] = useState([])
    const [meta, setMeta] = useState({})
    const [searchQuery, setSearchQuery] = useState('')
    const [currentPage, setCurrentPage] = useState(null)
    const [currentTab, setCurrentTab] = useState('library')

    useEffect(() => {
        getSite(siteId)

        fetchMedia({
            limit: 50,
        })
    }, [pageId])

    useEffect(() => {
        handleSearch()
    }, [currentPage])

    const fetchMedia = async (query) => {
        try {
            const mediaItems = await getMedia(query)
            console.log(mediaItems.data[0])
            setMedia(mediaItems.data)
            setMeta(mediaItems.meta)
            setIsLoading(false)
        } catch (err) {
            console.error(err)
            alert(
                `Error, something went wrong getting image picker modal \n ${err}`
            )
        }
    }

    const getSite = (siteId) => {
        config.sites.find((site) => {
            if (site.value === siteId) {
                setSite(site)
            }
        })
    }

    const handleSearchReturn = (event) => {
        let code = event.keyCode || event.which
        if (code === 13) {
            handleSearch()
        }
    }

    const handleSearch = () => {
        setIsLoading(true)

        /**
         * reset media
         */
        setMedia([])

        /**
         * Create new search object to use with api
         */
        let search_query = {
            ...(searchQuery.length
                ? {
                      search: searchQuery,
                  }
                : null),
            ...(currentPage !== null ? { page: currentPage } : null),
        }

        /**
         * Fetches pages with search query
         */
        fetchMedia({
            ...search_query,
            limit: 50,
        })
    }

    return (
        <div className="fixed z-40 top-0 left-0 w-screen h-screen bg-white overflow-auto">
            <div
                className="p-4 rounded-full bg-red-500 hover:bg-red-600 m-4 cursor-pointer shadow-lg inline-block transform hover:rotate-90 transition duration-150"
                onClick={() => props.closeImagePicker()}
            >
                <svg
                    className="w-6 h-6"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M18 6L6 18M6 6L18 18" />
                </svg>
            </div>
            <div className="container mx-auto p-4">
                <div>
                    <div className="flex flex-row items-center">
                        <button
                            onClick={() => setCurrentTab('library')}
                            className={`px-4 py-2 rounded mr-3 outline-none focus:outline-none flex flex-row items-center transition duration-150 ease-in-out ${
                                currentTab === 'library'
                                    ? 'bg-blue-500 text-white shadow'
                                    : 'bg-gray-400 text-gray-800 shadow-inner'
                            }`}
                        >
                            <span className="mr-2">
                                <svg
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-5 h-5 opacity-75"
                                >
                                    <rect
                                        x="3"
                                        y="3"
                                        width="18"
                                        height="18"
                                        rx="2"
                                        ry="2"
                                    ></rect>
                                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                                    <polyline points="21 15 16 10 5 21"></polyline>
                                </svg>
                            </span>
                            Media Library
                        </button>
                        <button
                            onClick={() => setCurrentTab('pixabay')}
                            className={`px-4 py-2 rounded mr-3 outline-none focus:outline-none flex flex-row items-center transition duration-150 ease-in-out ${
                                currentTab === 'pixabay'
                                    ? 'bg-blue-500 text-white shadow'
                                    : 'bg-gray-400 text-gray-800 shadow-inner'
                            }`}
                        >
                            <span className="mr-2">
                                <svg
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-5 h-5 opacity-75"
                                >
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line
                                        x1="14.31"
                                        y1="8"
                                        x2="20.05"
                                        y2="17.94"
                                    ></line>
                                    <line
                                        x1="9.69"
                                        y1="8"
                                        x2="21.17"
                                        y2="8"
                                    ></line>
                                    <line
                                        x1="7.38"
                                        y1="12"
                                        x2="13.12"
                                        y2="2.06"
                                    ></line>
                                    <line
                                        x1="9.69"
                                        y1="16"
                                        x2="3.95"
                                        y2="6.06"
                                    ></line>
                                    <line
                                        x1="14.31"
                                        y1="16"
                                        x2="2.83"
                                        y2="16"
                                    ></line>
                                    <line
                                        x1="16.62"
                                        y1="12"
                                        x2="10.88"
                                        y2="21.94"
                                    ></line>
                                </svg>
                            </span>
                            Pixabay
                        </button>
                    </div>
                </div>
                <div
                    className={`${
                        currentTab === 'pixabay' ? 'block' : 'hidden'
                    }`}
                >
                    <Pixabay handleMediaSelect={props.handleMediaSelect} />
                </div>
                <div
                    className={`${
                        currentTab === 'library' ? 'block' : 'hidden'
                    }`}
                >
                    <Upload getMedia={() => fetchMedia({ limit: 50 })} />
                    <div className="mt-12 mb-2 flex justify-between items-center">
                        <div>
                            <div className="text-2xl font-semibold">
                                Image Library
                            </div>
                            <div className="text-gray-700 text-sm">
                                Upload and manage media in your library
                            </div>
                        </div>
                        <div className="flex items-center flex-row">
                            <input
                                defaultValue={searchQuery}
                                onChange={(event) =>
                                    setSearchQuery(event.target.value)
                                }
                                placeholder="Search Media"
                                onKeyPress={handleSearchReturn}
                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-1 rounded outline-none w-full mr-2"
                            />
                            <div
                                onClick={handleSearch}
                                className={`border-2 border-blue-500 bg-blue-500 hover:bg-blue-600 hover:border-blue-600 inline-block text-white px-3 py-1 rounded cursor-pointer`}
                            >
                                Search
                            </div>
                        </div>
                    </div>
                </div>
                {isLoading && <div>Loading media...</div>}
                <div
                    className={`mb-4 ${
                        currentTab === 'library' ? 'block' : 'hidden'
                    }`}
                >
                    {!isLoading && (
                        <div className="flex flex-wrap">
                            {media.map((mediaItem) => (
                                <div
                                    onClick={() =>
                                        props.handleMediaSelect(mediaItem)
                                    }
                                    className="w-1/2 sm:w-1/2 md:w-1/3 lg:w-1/5 p-1 cursor-pointer"
                                >
                                    <img
                                        className="h-48 w-full object-cover rounded shadow overflow-auto"
                                        src={`${
                                            mediaItem.url_thumbnail.length ===
                                            42
                                                ? mediaItem.url
                                                : mediaItem.url_thumbnail
                                        }`}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div
                    className={`${
                        currentTab === 'library' ? 'block' : 'hidden'
                    }`}
                >
                    <Pagination meta={meta} setCurrentPage={setCurrentPage} />
                </div>
            </div>
        </div>
    )
}

const Pagination = ({ meta, setCurrentPage }) => (
    <div className="flex justify-between items-center">
        <div>
            {meta.total_results} Results - Page {meta.current_page} of{' '}
            {meta.total_pages}
        </div>
        <div className="flex items-center">
            <div className="mr-4">
                <button
                    disabled={meta.current_page > 1 ? false : true}
                    onClick={() => setCurrentPage(meta.current_page - 1)}
                    className={`px-3 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 ${
                        meta.current_page > 1
                            ? null
                            : 'cursor-not-allowed opacity-50'
                    } `}
                >
                    Prev
                </button>
            </div>
            <div>
                <button
                    disabled={
                        meta.current_page === meta.total_pages ? true : false
                    }
                    onClick={() => setCurrentPage(meta.current_page + 1)}
                    className={`px-3 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 ${
                        meta.current_page === meta.total_pages
                            ? 'cursor-not-allowed opacity-50'
                            : null
                    } `}
                >
                    Next
                </button>
            </div>
        </div>
    </div>
)

const Pixabay = ({ handleMediaSelect }) => {
    const [isSearching, setSearching] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [isUploading, setUploading] = useState(false)

    useEffect(() => {
        return () => {
            setUploading(false)
        }
    }, [])

    const handleSearch = () => {
        setSearching(true)
        searchPixabay().then((data) => {
            setSearching(false)
            setData(data)
        })
    }

    const searchPixabay = async () => {
        try {
            const api_url = `/.netlify/functions/pixabay`

            const results = await axios.get(api_url, {
                params: {
                    q: searchValue,
                    image_type: 'photo',
                    per_page: 100,
                },
            })

            return results.data
        } catch (err) {
            setSearching(false)
            alert('Something went wrong getting pixabay images')
            return err
        }
    }

    const handleImageClick = ({ largeImageURL, previewURL, tags }) => {
        /**
         * Handle upload process to s3
         * Then close image picker modal with new image URL
         */

        setUploading(true)

        handleS3Upload(largeImageURL, previewURL).then((images) => {
            /**
             * Uplaod was complete, return image object
             */
            let mediaObject = {
                url: `${config.imageBasePath}${images[0].key}`,
                url_thumbnail: `${config.imageBasePath}${images[1].key}`,
                description: `Image courtesy of Pixabay`,
            }

            createMediaItem({
                description: tags,
                attachment: images[0].key,
                attachment_thumbnail: images[1].key,
                type: 'image',
            }).then(() => {
                setUploading(false)
                handleMediaSelect(mediaObject)
            })
        })
    }

    const handleS3Upload = async (url, url_thumbnail) => {
        try {
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() + 1
            const expirationDate = date.getTime() + 31557600 //one year in seconds
            const fileExtension = 'jpg'

            const file = await fetch(url).then((r) => r.blob())
            const file_thumbnail = await fetch(url_thumbnail).then((r) =>
                r.blob()
            )

            const filename = `${year}/${month}/${Date.now()}.${fileExtension}`
            const thumbnail = `${year}/${month}/${Date.now()}-thumbnail.${fileExtension}`

            /**
             * Store regular image on s3
             */
            const stored = await Storage.put(filename, file, {
                contentType: 'image/jpeg',
                cacheControl: 'max-age=30758400',
                expires: expirationDate,
                contentEncoding: 'gzip',
                metadata: {
                    contentEncoding: 'gzip',
                    expires: expirationDate.toString(),
                },
            })

            /**
             * Store thumbnail on s3
             */
            const stored_thumb = await Storage.put(thumbnail, file_thumbnail, {
                contentType: 'image/jpeg',
                cacheControl: 'max-age=30758400',
                expires: expirationDate,
                contentEncoding: 'gzip',
                metadata: {
                    contentEncoding: 'gzip',
                    expires: expirationDate.toString(),
                },
            })

            return Promise.all([stored, stored_thumb]).then((images) => {
                // return both images
                return images
            })
        } catch (err) {
            alert(
                'something went wrong uploading image. Please refresh and try again'
            )
        }
    }

    return (
        <div className="mt-12">
            {isUploading && (
                <div className="fixed top-0 left-0 w-screen h-screen z-50 bg-black bg-opacity-50">
                    <div className="flex justify-center items-center py-12 text-white text-2xl text-center">
                        Uploading to post library...
                    </div>
                </div>
            )}
            <div className="text-2xl font-semibold">Search Pixabay</div>
            <div className="text-gray-700 text-sm mb-4">
                Search Pixabay for royalty free images
            </div>
            <div className="grid grid-cols-12 gap-4">
                <input
                    className="rounded-lg px-4 py-3 text-lg border-2 border-gray-300 focus:border-blue-500 flex-1 outline-none bg-gray-100 focus:bg-white col-span-10"
                    placeholder="Search"
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    onKeyPress={(event) =>
                        event.key === 'Enter' ? handleSearch() : null
                    }
                />
                <button
                    onClick={() => handleSearch()}
                    className="px-4 py-3 bg-blue-500 text-white text-lg rounded-lg col-span-2 hover:bg-blue-600"
                >
                    Search
                </button>
            </div>
            {isSearching && (
                <div className="text-center py-12 text-gray-600 text-lg">
                    Loading...
                </div>
            )}
            {!isSearching && data.hits && data.hits.length > 0 && (
                <>
                    <div className="text-gray-700 text-sm py-2 flex flex-row items-center">
                        <div>
                            Total Results:{' '}
                            <span className="font-bold">{data.total}</span>
                        </div>
                        <div className="ml-4 flex flex-row items-center">
                            <span className="text-green-500">
                                <svg
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="w-5 h-5 pr-1"
                                >
                                    <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path>
                                    <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>
                                </svg>
                            </span>
                            Note: Image previews are low resolution. High
                            quality will be used after selecting.
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 mt-4">
                        {data.hits.map((item) => (
                            <button
                                onClick={() => handleImageClick(item)}
                                className="border-2 border-transparent hover:border-blue-500 transition duration-75 ease-in-out rounded"
                            >
                                <img
                                    className="object-cover w-full h-24 bg-gray-100 rounded"
                                    src={item.webformatURL}
                                />
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default MediaPickerModal
